import React from "react";
import { Container, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import { useEffect } from "react";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateUserAndSubuserdashboardAction,
  getUserAndSubuserAction,
} from "../../../../redux/actions/ManageAdminAction";
const Enter = ({
  Passwordp,
  setPasswordp,
  Passwordc,
  setPasswordc,
  passwordInput,
  setPasswordInput,
  passwordconfirmInput,
  setpasswordconfirmInput,
  Phone,
  setPhone,
  Email,
  setEmail,
  Name,
  setName,
  Itemid,
  setLoading,
  setIsPress,
  loading,
  isPress,
}) => {
  const dispatch = useDispatch();
  const { UpdateUserAndsubuserdash } = useSelector(
    (state) => state.ManageAdminR
  );

  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Name === null || Phone === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "warn");
      return;
    }
    if (passwordInput !== null) {
      if (passwordconfirmInput !== passwordInput) {
        notify("يجب ان تكون كلمة السر متطابقة", "error");
        return;
      }
    }
    setLoading(true);
    setIsPress(true);
    await dispatch(
      UpdateUserAndSubuserdashboardAction({
        Id: Itemid,
        Name: Name,
        Email: Email,
        NewPassword: passwordInput,
      })
    );
    await dispatch(getUserAndSubuserAction());
    setName("");
    setPhone("");
    setEmail("");
    setPasswordInput("");
    setpasswordconfirmInput("");
    setLoading(false);
    setIsPress(false);
    
  };

  const tryChangePhone = () => {
    notify("غير مسموح بتغير رقم الهاتف", "warn");
  };
  useEffect(() => {
    if (loading === false) {
      if (UpdateUserAndsubuserdash && UpdateUserAndsubuserdash.data) {
        if (
          UpdateUserAndsubuserdash.data.ResponseMessage ===
         "Great, profile updated successfully"
        ) {
          notify("تم التعديل بنجاح", "success");
        }
        if (
          UpdateUserAndsubuserdash.data.ResponseMessage ===
          "Email is already registered!"
        ) {
          notify("هذا الإيميل مسجل من قبل", "success");
        }
        // if (
        //   UpdateUserAndsubuserdash.data.responseMessage !==
        //   "Great, profile updated succesfully"
        // ) {
        //   notify("حدثة مشكلة حاول مرة اخرى", "success");
        // }
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                value={Name}
                onChange={(e) => setName(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اسم المستخدم
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                  inputProps={{ maxLength: 120 }} 
                type="text"
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                value={Phone}
                onChange={tryChangePhone}
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    رقم الهاتف{" "}
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                 inputProps={{ maxLength: 15 }} 
                type="number"
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                focused
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    البريد الألكتروني
                    <span style={{ color: "red", fontSize: "11px" }}>
                      (أختياري)
                    </span>
                  </Typography>
                }
                variant="outlined"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                className="em"
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    كلمة المرور
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                type={Passwordp}
              />
              <button className="btn btn-primary e" onClick={togglep}>
                {Passwordp === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    تأكيد كلمة المرور
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                onChange={(e) => setpasswordconfirmInput(e.target.value)}
                type={Passwordc}
                value={passwordconfirmInput}
              />
              <button className="btn btn-primary c" onClick={togglec}>
                {Passwordc === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
            </div>
            <div className="inp-container "></div>
          </div>
          {isPress && loading ? (
            <button className="buttonadd">
              <Spinner animation="border" role="status"></Spinner>
            </button>
          ) : (
            <button className="buttonadd" onClick={handleUpdate}>
              تعديل
            </button>
          )}
        </Container>
      </div>
    </>
  );
};
export default Enter;
